module.exports = "/* nothing here */\r\n"